import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { PlusCircle, X, ChevronDown } from "lucide-react";

/**
 * A compact multi-select where chosen items appear as pills (with × to remove)
 * and a dropdown menu lists the remaining options for adding.
 */
export default function PillMultiSelect({
  options,
  selected,
  onToggle,
  addLabel = "Add",
  addLabelMore = "Add another",
  pillClass = "bg-sage-500 text-white",
  triggerClass = "border-sage-300 text-sage-700 hover:bg-sage-50",
  testidPrefix = "pms",
}) {
  const remaining = options.filter((o) => !selected.includes(o));
  const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

  return (
    <div className="flex flex-wrap gap-2 items-center" data-testid={`${testidPrefix}-picker`}>
      {selected.map((c) => (
        <span key={c} className={`inline-flex items-center gap-1.5 pl-3 pr-1.5 py-1 rounded-full text-sm ${pillClass}`} data-testid={`${testidPrefix}-pill-${slugify(c)}`}>
          {c}
          <button onClick={() => onToggle(c)} className="rounded-full hover:bg-black/10 p-0.5 transition-colors" data-testid={`${testidPrefix}-pill-${slugify(c)}-remove`} aria-label={`Remove ${c}`}>
            <X className="w-3 h-3"/>
          </button>
        </span>
      ))}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            disabled={remaining.length === 0}
            className={`inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm border border-dashed transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${triggerClass}`}
            data-testid={`${testidPrefix}-add-trigger`}
          >
            <PlusCircle className="w-3.5 h-3.5"/>
            {selected.length === 0 ? addLabel : addLabelMore}
            <ChevronDown className="w-3.5 h-3.5 opacity-60"/>
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-72 max-h-72 overflow-y-auto">
          {remaining.map((o) => (
            <DropdownMenuItem key={o} onSelect={() => onToggle(o)} data-testid={`${testidPrefix}-option-${slugify(o)}`} className="cursor-pointer">
              {o}
            </DropdownMenuItem>
          ))}
          {remaining.length === 0 && (
            <p className="text-xs text-stone-400 px-2 py-2">Nothing left to add.</p>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
